module.exports = __webpack_public_path__ + "img/appicon_square.c557901b.png";